import { ChangeEvent } from 'react';

import { OwnHome } from '@/hooks/useSubmitLeadToZeus';

import useStyles from './HomeOwnershipRadioContainer.styles';

export interface HomeOwnershipRadioContainerProps {
  homeOwnership: OwnHome;
  onHomeOwnershipChange: (value: OwnHome) => void;
}

/**
 * @deprecated V2 component
 */
const HomeOwnershipRadioContainer = ({
  homeOwnership,
  onHomeOwnershipChange,
}: HomeOwnershipRadioContainerProps) => {
  const { classes } = useStyles();

  function onHomeOwnershipRadioValueChange(
    event: ChangeEvent<HTMLInputElement>
  ) {
    onHomeOwnershipChange(event.target.value as OwnHome);
  }

  return (
    <div className={classes.homeOwnershipRadioContainer}>
      <label className={classes.inputLabel}>Do you own your own home?</label>
      <div style={{ display: 'flex' }}>
        <div className={classes.radioOption}>
          <input
            type='radio'
            value={OwnHome.OWN}
            checked={homeOwnership === OwnHome.OWN}
            onChange={onHomeOwnershipRadioValueChange}
            name='Own home'
            aria-label='Yes'
          />
          <label
            className={classes.homeOwnershipRadioOptionLabel}
            style={{ marginRight: 20 }}
          >
            Yes
          </label>
        </div>
        <div className={classes.radioOption}>
          <input
            type='radio'
            checked={homeOwnership === OwnHome.RENT}
            value={OwnHome.RENT}
            onChange={onHomeOwnershipRadioValueChange}
            name='Rent home'
            aria-label='No'
          />
          <label className={classes.homeOwnershipRadioOptionLabel}>No</label>
        </div>
      </div>
    </div>
  );
};

export default HomeOwnershipRadioContainer;
